export const cleaningReportColumn = [
    {
        Header: 'Id',
        accessor: 'id',
    },
    {
        Header: 'Emp. Name',
        accessor: 'empName',
    },
    {
        Header: 'Complete',
        accessor: 'complete',
    },
    {
        Header: 'Pending',
        accessor: 'pending',
    },
    {
        Header: 'Under Process',
        accessor: 'underProcess',
    }
]

export const cleaningReportData = [
      {
        "id": "01",
        "empName": "Jimmy",
        "complete": "0",
        "pending": "1",
        "underProcess": "0"
      },
      {
        "id": "02",
        "empName": "Depa",
        "complete": "0",
        "pending": "0",
        "underProcess": "0"
      },
      {
        "id": "03",
        "empName": "Moxi",
        "complete": "1",
        "pending": "1",
        "underProcess": "1"
      },
      {
        "id": "04",
        "empName": "Axa",
        "complete": "0",
        "pending": "0",
        "underProcess": "0"
      },
      {
        "id": "05",
        "empName": "Hiro",
        "complete": "0",
        "pending": "0",
        "underProcess": "0"
      },
      {
        "id": "06",
        "empName": "JOrdan",
        "complete": "1",
        "pending": "1",
        "underProcess": "0"
      },
      {
        "id": "07",
        "empName": "Meta",
        "complete": "0",
        "pending": "1",
        "underProcess": "0"
      },
      {
        "id": "08",
        "empName": "Heta",
        "complete": "1",
        "pending": "0",
        "underProcess": "1"
      },
      {
        "id": "09",
        "empName": "Mozo",
        "complete": "3",
        "pending": "0",
        "underProcess": "0"
      },
    ]
  